import styles from "./svgs.module.scss";

function DeliveryInStorePickupIcon(props: any) {
  const { width = 35, height = 35 } = props;
  return (
    <i className={`${styles.icon} ${styles.delivery_icons} ${styles.delivery_in_store_pickup}`} style={{ width, height, backgroundPosition: `0 -${width}px` }} />
  );
}

export default DeliveryInStorePickupIcon;
